import type { RouteRecordRaw } from 'vue-router';
import { familyRoutes } from './routes.family';

/**
 * Vitrine PRIVATE routes (Phase 2.2) — installed at runtime by the router guard when the authenticated
 * customer's ctype is SHOWCASE. Public/pre-auth routes live in routes.shared.ts. Each component is a
 * lazy import() so a FULL session never downloads these chunks. Per VITRINE_CLIENT_DESIGN.md §5.4.
 */
export const vitrinePrivateRoutes: RouteRecordRaw[] = [
  { path: '/card',     name: 'card',     component: () => import('@/views/vitrine/VitrineCardView.vue') },
  // Self-serve KYC document-upload step (docs/CLIENT_KYC_AND_CARD_ISSUANCE.md §5).
  { path: '/card/issuance', name: 'card-issuance', component: () => import('@/views/vitrine/CardIssuanceView.vue') },
  { path: '/history',  name: 'history',  component: () => import('@/views/vitrine/VitrineHistoryView.vue') },
  { path: '/settings', name: 'settings', component: () => import('@/views/vitrine/VitrineSettingsView.vue') },
  { path: '/topup',    name: 'topup',    component: () => import('@/views/vitrine/VitrineTopUpView.vue') },
  // «Пополнение общего баланса» — the master account's permanent addresses and movements (docs/cabinet-redesign/04 §8).
  // Reached only from the home hero and /topup when capabilities.masterAccount is on; off, the API answers
  // MASTER_ACCOUNT_OFF and the screen returns to the home.
  { path: '/topup/master', name: 'master-topup',
    component: () => import('@/views/cabinet/master/MasterTopUpView.vue') },
  // The concierge tab — one window for the general chat, request threads and concierge tasks
  // (docs/cabinet-redesign/02_ЭКРАНЫ_БЫЛО_СТАЛО.md §3). Not in the stage map: every stage may write to the manager.
  { path: '/concierge', name: 'concierge', component: () => import('@/views/cabinet/concierge/CabinetConciergeView.vue') },
  // The former «Платежи» screen: its address stays for old links and opens «Переписки» (query, incl. magic ?token=, kept).
  { path: '/payments', name: 'payments', redirect: to => ({ name: 'concierge', query: { ...to.query, threads: '1' } }) },
  // A task's feed — pushes and e-mails link here (StatusMessage.screenFor), so the address stays.
  { path: '/payments/:id', name: 'concierge-request',
    component: () => import('@/views/vitrine/concierge/VitrineConciergeRequestView.vue') },
  // The former support page: the chat now lives in the concierge tab; ?view=faq is the help page.
  { path: '/support', name: 'support', redirect: to => {
      const { view, ...rest } = to.query;
      return view === 'faq' ? { name: 'help', query: rest } : { name: 'concierge', query: rest };
    } },
  { path: '/help', name: 'help', component: () => import('@/views/cabinet/help/CabinetHelpView.vue') },
  // Family Office (read-only viewer + TSV export) — SHOWCASE clients with a grant get it too (§4.8).
  ...familyRoutes,
];
